import React from 'react';
import "./Projects.css";
import Work1 from "../../assets/work1.jpg";
import Work2 from "../../assets/work2.jpg";
import Work3 from "../../assets/work3.jpg";

const Projects = () => {
  const projects = [
    {
      id: 1,
      image: Work3,
      title: "ARCHUB",
      description: "Rest-ful API and Express JS E-Commerce & OEM WEB Application",
      link: "https://www.archub.in"
    },
    {
      id: 2,
      image: Work1,
      title: "Real Time Chatbot",
      description: "python fast api and websocket real time AI chatbot",
      link: "https://ai.farhansaifi.in"
    },
    {
      id: 3,
      image: Work2,
      title: "Secret Chat Application",
      description: "E2EE security real time secret chat application with friends",
      link: "https://livechat.farhansaifi.in"
    },
  ];

  return (
    <section className="projects section" id="projects">
      <h2 className="section__title" data-aos="fade-down">Projects</h2>
      <span className="section__subtitle" data-aos="fade-down" data-aos-delay="200">My recent work</span>

      <div className="projects__container container grid">
        {projects.map((project) => (
          <div className="project__card" key={project.id} data-aos="flip-left" data-aos-delay={200 + project.id * 100}>
            <div className="project__img-container">
              <img src={project.image} alt="" className="project__img" />
              <div className="project__overlay">
                <a href={project.link} className="project__button">
                  View Project <i className="bx bx-right-arrow-alt project__button-icon"></i>
                </a>
              </div>
            </div>
            <h3 className="project__title">{project.title}</h3>
            <p className="project__description">{project.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;